import { permissionhost as host } from './permission-config-host'

export const getPermissionTable = params => {
  return axios.post(`${host(params)}/permissions/query`, params)
}
export const getPermissionGroupTable = params => {
  return axios.get(`${host(params)}/permissions/group/list`, {params})
}
export const getPermissionGroupDetail = params => {
  return axios.get(`${host(params)}/getPermissionGroupDetail/${params.id}`, {params})
}
export const exportPermissionGroupData = params => {
  return axios.get(`${host(params)}/exportPermissionGroupData/${params.id}`, {params})
}
export const createPermissionGroupData = params => {
  return axios.post(`${host(params)}/permissions/group/add`, params)
}
export const updatePermissionGroupData = params => {
  return axios.post(`${host(params)}/permissions/group/edit_${params.id}`, params)
}
export const deletePermissionGroupData = params => {
  return axios.post(`${host(params)}/permissions/group/remove_${params.id}`, params)
}
export const savePermissionGroupData = params => {
  return axios.post(`${host(params)}/permissions/group/batch_edit`, params)
}
export const getPermissionPlatformlist = params => {
  return axios.get(`${host(params)}/admin/adminuser/platformlist`, {params})
}



// WEBPACK FOOTER //
// ./src/views/permission-group/permission-group.api.js